import initialState from './initial';
import * as types from '../constants/calculations';

const CalculationsReducer = (state = initialState.calculations, action) => {
    const { type, payload } = action;
    switch (type) {
        case types.PENSION_ANALYSIS_CALCULATION_REQUEST: {
            return { ...state, type: types.PENSION_ANALYSIS, isCalculating: true };
        }
        case types.PENSION_ANALYSIS_CALCULATION_SUCCESS: {
            return { ...state, pensionAnalysis: payload.pensionAnalysis, pensionHistory: payload.pensionHistory, type: types.PENSION_ANALYSIS, isCalculating: false, calculated: true };
        }
        case types.PENSION_ANALYSIS_CALCULATION_FAIL: {
            return { ...state, error: payload, type: types.PENSION_ANALYSIS, isCalculating: false };
        }
        case types.PENSION_ANALYSIS_CALCULATION_RESET: {
            return initialState.calculations;
        }
        default:
            return state;
    }
};
export default CalculationsReducer;
